import { createContext, useContext } from 'react';
const MediaBridgeContext = /*#__PURE__*/createContext({
  iframeLoaded: false,
  panelOpen: false
});
export const useMediaBridgeContext = () => useContext(MediaBridgeContext);
export default MediaBridgeContext;